import classes from './Home.module.css';

const Home = () => {
    return (
        <div className={classes.home}>
            <section className={classes.hero}>
                <div className={classes.container}>
                    <div className={classes.heroContent}>
                        <h1 className={classes.heroTitle}>Doorstep Service in 30 minutes</h1>
                        <h2 className={classes.heroSubtitle}>Appliance Repair Services</h2>
                        <p className={classes.heroDescription}>
                            We repair all appliances, including washing machines, refrigerators, microwaves, TVs, ACs, and music systems. 
                            Experience quality service and satisfaction!
                        </p>
                        <div className={classes.heroButtons}>
                            <a href="tel:8879552122" className={classes.callButton}>8879552122</a>
                            <button className={classes.bookButton}>BOOK NOW</button>
                        </div>
                    </div>
                </div>
            </section>

            <section className={classes.services}>
                <div className={classes.container}>
                    <h2 className={classes.sectionTitle}>Services</h2>
                    <p className={classes.sectionDescription}>
                        EmpireService provides expert repair services for washing machines, refrigerators, 
                        microwaves, TVs, ACs, and music systems to keep your home running perfectly.
                    </p>
                    <div className={classes.serviceGrid}>
                        <div className={classes.serviceCard}>
                            <div className={classes.serviceIcon}>🧊</div>
                            <h3>Refrigerator Repair</h3>
                            <p>Expert repair services for all refrigerator brands and models</p>
                        </div>
                        <div className={classes.serviceCard}>
                            <div className={classes.serviceIcon}>🌀</div>
                            <h3>Washing Machine Repair</h3>
                            <p>Professional washing machine repair and maintenance services</p>
                        </div>
                        <div className={classes.serviceCard}>
                            <div className={classes.serviceIcon}>📦</div>
                            <h3>Microwave Oven Repair</h3>
                            <p>Quick and reliable microwave oven repair solutions</p>
                        </div>
                        <div className={classes.serviceCard}>
                            <div className={classes.serviceIcon}>📺</div>
                            <h3>TV Repair</h3>
                            <p>Professional TV repair services for LED, LCD, OLED, and Smart TVs</p>
                        </div>
                        <div className={classes.serviceCard}>
                            <div className={classes.serviceIcon}>❄️</div>
                            <h3>AC Repair</h3>
                            <p>Expert AC repair services for window, split, and inverter ACs</p>
                        </div>
                        <div className={classes.serviceCard}>
                            <div className={classes.serviceIcon}>🎵</div>
                            <h3>Music System Repair</h3>
                            <p>Professional music system repair for home theaters, speakers, and amplifiers</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className={classes.cta}>
                <div className={classes.container}>
                    <h2 className={classes.ctaTitle}>Avail Our Services Today</h2>
                    <p className={classes.ctaDescription}>
                        Don't let a malfunctioning appliance disrupt your routine. Contact EmpireService 
                        today and experience our efficient and reliable repair services. Book your appliance 
                        repair visit now and say goodbye to inconvenience!
                    </p>
                    <a href="tel:8879552122" className={classes.ctaButton}>BOOK NOW</a>
                </div>
            </section>

            <section className={classes.features}>
                <div className={classes.container}>
                    <h2 className={classes.sectionTitle}>Quality Solutions for Your Appliances</h2>
                    <p className={classes.sectionDescription}>
                        We are committed to delivering high-quality solutions for all your appliance repair needs. 
                        Our expertise and dedication ensure that your appliances receive the best care, keeping them running smoothly.
                    </p>
                    <div className={classes.featureGrid}>
                        <div className={classes.featureCard}>
                            <div className={classes.featureIcon}>⏰</div>
                            <h3>Always Available for You</h3>
                            <p>
                                At EmpireService, we prioritize your convenience. We are always open to serve you, 
                                addressing your appliance repair requirements at a time that suits you best. Your satisfaction is our top priority.
                            </p>
                        </div>
                        <div className={classes.featureCard}>
                            <div className={classes.featureIcon}>💰</div>
                            <h3>Affordable Pricing</h3>
                            <p>
                                We believe in transparent and competitive pricing. Our appliance repair services come at 
                                unbeatable prices, offering you value for your money without compromising on the quality of work.
                            </p>
                        </div>
                        <div className={classes.featureCard}>
                            <div className={classes.featureIcon}>🔧</div>
                            <h3>Expert Technicians</h3>
                            <p>
                                Our team comprises professionally qualified and experienced technicians who possess the 
                                skills to handle all types of appliance repairs. You can trust us to deliver professional and reliable service every time.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className={classes.testimonials}>
                <div className={classes.container}>
                    <h2 className={classes.sectionTitle}>What Our Customers Say</h2>
                    <div className={classes.testimonialGrid}>
                        <div className={classes.testimonialCard}>
                            <p>"Excellent service! They repaired my refrigerator within hours."</p>
                            <h4>- Rajesh Khanna, Kandivali</h4>
                        </div>
                        <div className={classes.testimonialCard}>
                            <p>"Professional technicians and reasonable prices. Highly recommended!"</p>
                            <h4>- Anita Deshmukh, Andheri</h4>
                        </div>
                        <div className={classes.testimonialCard}>
                            <p>"Quick response time and quality work. Very satisfied with their service."</p>
                            <h4>- Vikram Singh, Bandra</h4>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;